import { memberApiV2 } from '@lib/api';
import {
  GetPatientPrescriptionsRes,
  GetPatientReceiptsRes,
  GetPrescriptionsParams,
  GetReceiptsParams,
  IPrescriptionTableItem,
} from 'types/e-prescription.types';

export function getPatientReceipts(providerId: string, params: GetReceiptsParams) {
  return memberApiV2.request<{ data: GetPatientReceiptsRes }>(
    '/management/private/medical-data/receipt/get-receipts',
    {
      method: 'GET',
      params,
      headers: { 'provider-id': providerId },
    },
  );
}

export function getPatientPrescriptionsRequests(
  providerId: string,
  params: GetPrescriptionsParams,
) {
  return memberApiV2.request<{ data: GetPatientPrescriptionsRes }>(
    '/management/private/medical-data/receipt/requests',
    {
      method: 'GET',
      params,
      headers: { 'provider-id': providerId },
    },
  );
}

export function getPrescriptionsRequests(providerId: string) {
  return memberApiV2.request<{ data: IPrescriptionTableItem[] }>(
    '/management/private/medical-data/receipt/request/client/count',
    {
      method: 'GET',
      headers: { 'provider-id': providerId },
    },
  );
}
